<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { projectData } from "./data-projects";
import Loader from "../components/loader";
import api from "@/axios";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import AstronautJSON from '@/assets/animations/facial_anim.json'
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Reconhecimento Facial",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vue3Lottie,
  },
  data() {
    return {
      AstronautJSON,
      updating: true,
      projectData: projectData,
      title: "Reconhecimento Facial",
      items: [
        {
          text: "Redes Sociais",
          href: "/",
        },
        {
          text: "Reconhecimento Facial",
          active: true,
        },
      ],
    };
  },
  mounted() {
    console.log('mounted condicoes-list_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  },
  methods: {
    novoCliente(){
      this.$router.push({path: "/cliente/editar/0", force: true })
    },

    abrirAdCreative(){
      console.log('abrirAdCreative')
      window.open('https://pt.adcreative.ai/', '_blank');
    },

    abrirManyContent(){
      console.log('abrirManyContent')
      window.open('https://manycontent.com/', '_blank');
    },

  }
};
</script>

<template>
  <Layout>


    <span class="float-end" style="z-index: 1000; position: absolute; top: 20px; right: 220px;">
      <Vue3Lottie :animationData="AstronautJSON" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />



    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-info" class="mx-2"  @click="novoCliente">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Cliente
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="abrirAdCreative" >
                <i class="bx bx-layer font-size-16 align-middle me-2"></i>
                Ad. Creative
              </b-button>



              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-danger" class="mx-2" @click="cancelarOrcamento"  >-->
              <!--                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>-->
              <!--                Cancelar Orçamento-->
              <!--              </b-button>-->

              <b-button variant="outline-warning" class="mx-2" @click="abrirManyContent" >
                <i class="bx bx-git-pull-request font-size-16 align-middle me-2"></i>
                Many Content
              </b-button>

            </div>
          </div>
        </div>
      </div>

    </div>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div v-for="grid in projectData" :key="grid.id" class="col-xl-4 col-sm-6">

        <router-link :to="`/postagem/detalhe/1`">
          <div class="card">

            <div class="card-body">
              <div class="d-flex">


                <div class="avatar-md me-4">
                  <span
                      class="avatar-title rounded-circle bg-light text-danger font-size-16"
                  >
                    <img :src="`${grid.image}`" alt height="50" />
                  </span>
                </div>

                <div class="flex-grow-1 overflow-hidden">
                  <h5 class="text-truncate font-size-15">
                    <span class="text-dark">{{
                        grid.text
                      }}</span>
                  </h5>
                  <p class="text-muted mb-4">{{ grid.subtext }}</p>
                  <div class="avatar-group">
                    <div class="avatar-group-item">
                      <a
                          href="javascript: void(0);"
                          class="d-inline-block"
                      >
                        <img
                            :src="`${grid.users[0]}`"
                            class="rounded-circle avatar-xs"
                            alt
                        />
                      </a>
                    </div>
                    <div class="avatar-group-item" v-if="grid.users[1]">
                      <a
                          href="javascript: void(0);"
                          class="d-inline-block"
                      >
                        <img
                            :src="`${grid.users[1]}`"
                            class="rounded-circle avatar-xs"
                            alt
                        />
                      </a>
                    </div>
                    <div class="avatar-group-item" v-if="grid.users[2]">
                      <a
                          href="javascript: void(0);"
                          class="d-inline-block"
                      >
                        <img
                            :src="`${grid.users[2]}`"
                            class="rounded-circle avatar-xs"
                            alt
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-4 py-3 border-top">
              <ul class="list-inline mb-0">
                <li class="list-inline-item me-3">
                  <span
                      class="badge"
                      :class="{
                      'bg-success': `${grid.status}` === 'Concluído',
                      'bg-warning': `${grid.status}` === 'Pendente',
                      'bg-danger': `${grid.status}` === 'Atraso',
                    }"
                  >{{ grid.status }}</span
                  >
                </li>
                <li
                    v-b-tooltip.hover.top
                    class="list-inline-item me-3"
                    title="Due Date"
                >
                  <i class="bx bx-calendar me-1"></i>
                  {{ grid.date }}
                </li>
                <li
                    v-b-tooltip.hover.top
                    class="list-inline-item me-3"
                    title="Interações"
                >
                  <i class="bx bx-comment-dots me-1"></i>
                  {{ grid.comment }}
                </li>
              </ul>
            </div>
          </div>
        </router-link>

      </div>
    </div>
    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <ul
            class="pagination pagination-rounded justify-content-center mt-2 mb-5"
        >
          <li class="page-item disabled">
            <a href="#" class="page-link">
              <i class="mdi mdi-chevron-left"></i>
            </a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">1</a>
          </li>
          <li class="page-item active">
            <a href="#" class="page-link">2</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">3</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">4</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">5</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">
              <i class="mdi mdi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- end ro w -->
  </Layout>
</template>
